import { render, staticRenderFns } from "./Extensions1.vue?vue&type=template&id=3d06bd44&scoped=true"
import script from "./Extensions1.vue?vue&type=script&lang=js"
export * from "./Extensions1.vue?vue&type=script&lang=js"
import style0 from "./Extensions1.vue?vue&type=style&index=0&id=3d06bd44&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d06bd44",
  null
  
)

export default component.exports